import { render } from "./LieferantEditAccountDialog.vue?vue&type=template&id=b60452ec&ts=true"
import script from "./LieferantEditAccountDialog.vue?vue&type=script&lang=ts"
export * from "./LieferantEditAccountDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__